// extracted by mini-css-extract-plugin
export default {"container":"Support_container__2Ga--","emailLink":"Support_emailLink__pFs+c","contactBox":"Support_contactBox__W8pf1"};